const Search = ( () => {
	function fadeMainMenuOnSearch( e ) {
		const header = e.target.closest( '.wp-block-clowns-header' );
		const event = e.type;

		if ( ! header ) {
			return;
		}

		if ( event === 'focusout' ) {
			header.classList.remove( 'search-focused' );
		} else {
			header.classList.add( 'search-focused' );
		}
	}

	function init() {
		const searchInput = document.querySelector( '#search' );
		if ( searchInput ) {
			searchInput.addEventListener( 'focus', fadeMainMenuOnSearch );
			searchInput.addEventListener( 'focusout', fadeMainMenuOnSearch );
		}
	}

	return {
		init,
	};
} )();

export default Search;
